export const THEMES = [
  { id: "clinical", label: "Clinical", dark: false },
  { id: "paper", label: "Paper", dark: false },
  { id: "ink", label: "Ink", dark: true },
  { id: "light", label: "Light", dark: false },
  { id: "dark", label: "Dark", dark: true },
] as const;

export const LIGHT_THEME_IDS: Set<string> = new Set(
  THEMES.filter((t) => !t.dark).map((t) => t.id),
);

export function applyTheme(id: string) {
  if (id === "light") {
    delete document.documentElement.dataset.theme;
  } else {
    document.documentElement.dataset.theme = id;
  }
  localStorage.setItem("theme", id);
}
